module.exports = __webpack_public_path__ + "img/car-dark.f2fd7706.svg";